import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"
import { BuildingType } from "shared/types/references/BuildingType"

import { ParseKeys } from "i18next"

export function useBuildingTypeOptions(): SelectOption<BuildingType>[] {
  const { t } = useTranslation()

  return useMemo(
    () =>
      Object.values(BuildingType)
        .map(buildingType => ({
          label: t(
            `BuildingReference.BuildingType.${buildingType}` as ParseKeys
          ) as string,
          value: buildingType
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [t]
  )
}
